<p>Token is valid!</p>
<br />
<p>Redirecting to the last 4 phone digits validation page</p>
